var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgBaseIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 21,
    height: 20,
    viewBox: "0 0 21 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M1.5011 10.7989H13.0733C13.4501 10.7989 13.4507 10.7989 13.4512 10.4203C13.4512 10.127 13.4314 9.83158 13.4567 9.53996C13.482 9.24835 13.366 9.19168 13.0976 9.19278C10.6136 9.20213 8.13016 9.19828 5.64674 9.19828H1.5C1.82507 4.8516 5.58678 0.976994 10.5393 1.0001C15.4688 1.02376 19.6095 5.09039 19.4978 10.2013C19.3933 15.0366 15.4473 18.9371 10.6042 18.9992C5.61098 19.0631 1.81517 15.1516 1.5011 10.7989Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBaseIcon);
export default __webpack_public_path__ + "static/media/BaseIcon.35b327f107b885fad46160dd10fc8942.svg";
export { ForwardRef as ReactComponent };